// extracted by mini-css-extract-plugin
module.exports = {"loadingContainer":"ResidentManagement_loadingContainer__2x14Q"};